export enum AmmoType {
  Poison = 'poison',
  Blood = 'serrated',
  Blind = 'blinding',
  Web = 'crippling',
  Burning = 'burning',
  Fist = 'heavy',
  Silver = 'silver',
  Blank = 'basic',
}
